var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomelinkAppTile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "90px",
    height: "90px",
    viewBox: "0 0 90 90",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0_4_Icons_MIB3 / 0_4_3_IconMaster / home / homelink_app_tile") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "16.1630824%",
    x2: "84.6270161%",
    y2: "168.160925%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B0F4",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F448C",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "78.1115987%",
    x2: "50%",
    y2: "23.8575582%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E5E5",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCCCC",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "0_4_Icons_MIB3-/-0_4_3_IconMaster-/-home-/-homelink_app_tile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Homelink",
    transform: "translate(4.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,71 C2.76142375,71 5,73.2385763 5,76 L0,76 L0,71 L0,71 Z M0,59 C9.38884075,59 17,66.6111593 17,76 L12,76 L12,76 C12,69.372583 6.627417,64 0,64 L0,59 L0,59 Z M0,47 C16.0162577,47 29,59.9837423 29,76 L24,76 L24,76 C24,62.745166 13.254834,52 0,52 L0,47 L0,47 Z M0,35 C22.6436747,35 41,53.3563253 41,76 L36,76 L36,76 C36,56.117749 19.882251,40 0,40 L0,35 L0,35 Z",
    id: "Waves---Fill",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.433835,0 L82,24 L82,62 L45.9262245,61.9999084 C45.2983611,59.9376238 44.5353978,57.9342044 43.6476433,55.9999589 L76,56 L76,27.6190476 L47.4453419,8 L19,27.6190476 L19.0011577,31.9076788 C17.0637457,31.0716483 15.0603079,30.3595741 13.0008371,29.7814489 L13,24 L47.433835,0 Z",
    id: "Our-House---Fill",
    fill: "url(#linearGradient-2)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4349302,1.21816795 L81,24.5230869 L81,60.9999975 L46.6611644,60.9999102 C46.2242442,59.639719 45.7295092,58.3054378 45.1798506,56.9999608 L45.1798506,56.9999608 L77,57.0000013 L77,27.0928307 L47.4442545,6.78596593 L17.9998582,27.0940717 L18.000754,30.4123888 C16.6939895,29.8959834 15.3597115,29.4341321 14.0007282,29.0296412 L14.0007282,29.0296412 L14.0000756,24.5218897 L47.4349302,1.21816795 Z",
    id: "Our-House---Border",
    stroke: "#DDDDDD",
    strokeWidth: 2,
    fillRule: "nonzero"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomelinkAppTile);
export default __webpack_public_path__ + "static/media/homelink_app_tile.58cafc2b94b9573378100f192050d64f.svg";
export { ForwardRef as ReactComponent };